import { useState } from "react";
import Input from "../../../../../components/Input";
import InputSelect from "../../../../../components/Input-select";
import Textarea from "../../../../../components/Textarea";
import useAuthData from "../../../../../hook/useAppData";
import "./index.scss";
import { sendFeedback } from "./service";

const FLAGSELECT = [
  { value: 1, name: "Sugestão" },
  { value: 2, name: "Relatar um bug" },
];

interface FeedbackProps {
  handleCancelClick: () => void;
}

function Feedback({ handleCancelClick }: FeedbackProps) {
  const [values, setValues] = useState({ title: "", flag: 0, message: "" });

  const [error] = useState({ message: "Selecione uma opção" });
  const [status, setStatus] = useState(false);

  const { token } = useAuthData();

  function handleSelectField(e: any) {
    setStatus(false);
    setValues({
      ...values,
      flag: +e.target.value,
    });
  }

  function handleSubmitClick(e: any) {
    e.preventDefault();
    if (!values.flag) {
      setStatus(true);
      return;
    }

    handleCancelClick();
    sendFeedback(token, values);
  }

  return (
    <>
      <div className="feedback font-poppins">
        <div className="feedback__content">
          <h1 className="feedback__title">Enviar um feedback</h1>
          <p>Gostaria de enviar uma sugestão ou relatar um bug?</p>
          <p>Escreva no campo abaixo e nos ajude a melhorar nosso produto.</p>
        </div>

        <form onSubmit={handleSubmitClick}>
          <Input
            name="title"
            label="Titulo"
            placeholder="Uma breve descrição"
            value={values.title}
            setValue={(e) =>
              setValues({
                ...values,
                title: e.target.value,
              })
            }
            required={true}
            asterisk
          />

          <InputSelect
            required
            name="flag"
            label="Opção"
            list={FLAGSELECT}
            onChange={(e) => handleSelectField(e)}
            value={values.flag}
            errorMessage={error.message}
            errorStatus={status}
          />

          <Textarea
            label="Mensagem"
            name="message"
            placeholder="Escreva sua mensagem..."
            value={values.message}
            rows={5}
            setValue={(e) =>
              setValues({
                ...values,
                message: e.target.value,
              })
            }
            required
            asterisk
          />
          <div className="feedback__wrapperButton">
            <button className="btn bg-primary color-text-contrast" type="submit">
              Enviar o feedback
            </button>
            <button className="btn bg-secondary color-text-contrast" type="button" onClick={handleCancelClick}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default Feedback;
